import { createSafeJotaiLocalStorage } from '@heidi/utils/jotai-storage';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

/**
 * The Heidi II Evidence tour's spotlights: 0 on the rail's Home item (any page
 * with the rail), 1 on Recents in the Home panel, then 2 on the Evidence-only
 * row in the Work home composer + menu.
 */
export type Heidi2EvidenceTourStep = 0 | 1 | 2;

export const HEIDI_2_EVIDENCE_TOUR_TOTAL_STEPS = 3;

/**
 * Which step of the Heidi II Evidence tour is showing. All three are one queue
 * entry (`HEIDI_2_EVIDENCE_TOUR_SPOTLIGHT_MODAL_ID`), so this only says which
 * anchor draws it; the queue decides whether it shows at all.
 *
 * In memory on purpose: a reload mid-tour starts it again from the rail, and
 * the tour only advances after "Next".
 */
export const heidi2EvidenceTourStepAtom = atom<Heidi2EvidenceTourStep>(0);

/**
 * True after "Next" on the rail spotlight, until Home is reached. Keeps the
 * tour's queue slot during the walk so other launch surfaces cannot cut in.
 */
export const heidi2EvidenceTourHeadingHomeAtom = atom(false);

/**
 * How many copies of the Work home composer's + menu (step 2's anchor) are
 * mounted. It leaves once a message is sent or a chat opens, and step 2 must
 * not hold the queue slot with nothing on screen. A count, not a flag: the
 * composer can mount toolbar and compact copies at once, and an exiting copy
 * must not clear the one still on screen.
 */
export const heidi2EvidenceTourAddMenuMountCountAtom = atom(0);

/**
 * True while the rail's Home item (step 0's anchor) is mounted. Pages without
 * the rail must not hold the queue slot with nothing on screen.
 */
export const heidi2EvidenceTourRailMountedAtom = atom(false);

export const heidi2EvidenceTourHomeVisitedAtom = atomWithStorage<boolean>(
  'heidi-2-evidence-tour-home-visited',
  false,
  createSafeJotaiLocalStorage<boolean>(),
  { getOnInit: true }
);
